import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';



const BidPrices = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main">
                <div id="maintable" className='last_trade Common_warrent' style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav">
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Last Traded prices</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Monitoring price changes</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Bid prices</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Closing times</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Tracking Warrant's Price Change - bid price</title>
                            <style dangerouslySetInnerHTML={{__html: "\n            .imgholder img{\n                max-width: 600px; \n/*                max-height: 247px; */\n            }\n        " }} />
                            <div className="contentbox">
                                <p>
                                The most accurate way to calculate the price change for a warrant is to look at the change in bid prices over the period. The bid price shows the price at which you can sell your warrants and is therefore the best representation of its value at any point in time.<br /><br />  
                                The example below shows the two different methods for calculating a warrant price change. In this case, the investor wants to know how the warrant price has changed since yesterday’s close and to compare this to the underlying share price change for the same period:<br /><br />
                                Unreliable way of calculating daily price change using last traded price:
                                </p>
                                <div className="imgholder11">
                                <img src='/img/education/bidprice01.jpg' alt="image" />
                                </div>
                                <div className="imgholder_mobile">
                                <img src='/img/education/bidprice01_m.jpg' alt="image" />
                                </div>
                                <p>
                                The above shows the method that would be published by most publicly available information sources. In this case, it is totally inaccurate as the “last traded price” for the warrant that is used as the “closing price” actually occurred the previous morning. Therefore it is inaccurate to compare this to the share price change that recorded its last trade at market close.<br /><br />
                                Most accurate to look at bid prices over period of comparison:
                                </p>
                                <div className="imgholder11">
                                <img src='/img/education/bidprice02.jpg' alt="image" />
                                </div>
                                <div className="imgholder_mobile">
                                <img src='/img/education/bidprice02_m.jpg' alt="image" />
                                </div>
                                <p>The most accurate way to calculate the price change for a warrant is to look at the change in bid prices over the period. So in this example, the investor would look at where the bid price for the warrant was just before the market close the previous day, and to compare that with the current bid price. In this way, the period of comparison for the share and warrant are the same.</p>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                    Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                    </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                                 <Link to="/edu/monitoring-price-changes/closing-times">
                                   Closing times
                                   </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/monitoring-price-changes/closing-times">
                            <div className="next right" />
                        </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/monitoring-price-changes/last-traded-price">
                            <div className="prev left" />
                        </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            > <Link to="/edu/monitoring-price-changes/last-traded-price">
                                Last Traded prices
                                </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default BidPrices;